import { useEffect } from "react";

const DEFAULT_TIMEOUT = 18000000; // Default: 30 min

const useSessionTimeout = (onLogout, timeoutDuration = DEFAULT_TIMEOUT) => {
  useEffect(() => {
    let logoutTimer;

    const resetTimer = () => {
      clearTimeout(logoutTimer);
      logoutTimer = setTimeout(() => {
        onLogout();  // Call logout function from parent component
      }, timeoutDuration);
    };

    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keydown", resetTimer);
    window.addEventListener("click", resetTimer);

    resetTimer();

    return () => {
      clearTimeout(logoutTimer);
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keydown", resetTimer);
      window.removeEventListener("click", resetTimer);
    };
  }, [onLogout, timeoutDuration]);
};

export default useSessionTimeout;
